import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from '@material-ui/core/styles';

import { DatePicker } from 'material-ui-pickers';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { AddButton } from 'components/core';
import {
  Rebill,
  Cogs,
  Expense
} from '../Dialog';
import { VendorDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing.unit,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  leftCard: {
    margin: theme.spacing.unit*2,
  },
  rightCard: {
    margin: theme.spacing.unit*2,
  },
  padding: {
    padding: theme.spacing.unit,
  },
  basics: {
    width: '250px',
    height: '350px',
  },
  receiptType: {
    width: '250px',
    height: '350px',
  },
  smallField: {
    marginTop: theme.spacing.unit*2,
    width: '110px',
  },
  notes: {
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  cardWidth: {
    width: "320px",
    height: "400px",
  },
  marginBottom: {
    marginBottom: theme.spacing.unit*2,
  },
  viewReceiptContent: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: theme.spacing.unit*3,
  },
  field: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    width: '230px',
  },
  formControl: {
    width: '230px',
    margin: '0px',
    marginRight: theme.spacing.unit*2,
  },
  addRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  taxRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit,
    width: '230px',
  }
});

class ReceiptContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      showAddVendor: false,
    };
  }

  handleClose(){
    this.setState({ showDialog: false });
  }

  render() {
    const {
      classes,
      receipt,
      showValidation,
      validation,
      vendors,
      handleChange
    } = this.props;
    const {
      showAddVendor,
      showDialog,
    } = this.state;

    return (
      <div className={classes.root}>
        <VendorDialog
          show={showAddVendor}
          handleCreated={(result) => {
            handleChange("vendorId", result);
          }}
          handleClose={() => this.setState({ showAddVendor: false })}
        />
        {showDialog &&
          <Dialog
            open={true}
            onClose={this.handleClose.bind(this)}
          >
            <DialogTitle>Receipt Image</DialogTitle>
            <div
              style={{
                width: "600px",
                height: "600px",
                backgroundImage: `url(${receipt.downloadURL})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 50%',
              }}
            ></div>
            <DialogActions>
              <Button onClick={this.handleClose.bind(this)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        }
        <div className={classes.row}>
          <Card className={classNames(classes.cardWidth, classes.basics, classes.leftCard, classes.padding)}>
            <CardHeader
              title="The Basics"
            />
            <CardContent>
              <div className={classes.marginBottom}>
                <DatePicker
                  className={classes.field}
                  label="Date"
                  format="MMMM Do YYYY"
                  value={new Date()}
                  leftArrowIcon={<ArrowBackIcon />}
                  rightArrowIcon={<ArrowForwardIcon />}
                  onChange={(date) => handleChange("date", date.toDate().getTime())}
                />
              </div>
              <div className={classes.addRow}>
                <FormControl
                  className={classes.formControl}
                  fullWidth
                >
                  <InputLabel htmlFor="vendor-simple">Vendor</InputLabel>
                  <Select
                    value={receipt.vendorId === undefined ? "" : receipt.vendorId}
                    onChange={(event) => {
                      handleChange("vendorId", event.target.value);
                    }}
                    inputProps={{
                      name: 'vendorId',
                      id: 'vendor-simple',
                    }}
                  >
                    {vendors &&
                      vendors.map((vendor, i) => {
                        return <MenuItem key={i} value={vendor.id}>{vendor.name}</MenuItem>
                      })
                    }
                  </Select>
                </FormControl>
                <AddButton
                  onClick={() => this.setState({ showAddVendor: true })}
                />
              </div>
              <div className={classes.taxRow}>
                 <FormControl
                   error={(showValidation && !!validation.validateField("tax"))}
                   fullWidth
                   style={{marginRight: "10px"}}
                  >
                   <InputLabel htmlFor="tax">Tax</InputLabel>
                   <Input
                     id="tax"
                     type="number"
                     value={receipt.tax}
                     onChange={(event) => handleChange("tax", event.target.value)}
                     startAdornment={<InputAdornment position="start">$</InputAdornment>}
                   />
                  {showValidation && validation.validateField("tax") &&
                     <FormHelperText>{validation.validateField("tax")}</FormHelperText>
                   }
                 </FormControl>
                 <FormControl
                   error={(showValidation && !!validation.validateField("total"))}
                   fullWidth
                   style={{marginLeft: "10px"}}
                  >
                    <InputLabel htmlFor="total">Total</InputLabel>
                    <Input
                      id="total"
                      type="number"
                      value={receipt.total}
                      onChange={(event) => handleChange("total", event.target.value)}
                      startAdornment={<InputAdornment position="start">$</InputAdornment>}
                    />
                    {showValidation && validation.validateField("total") &&
                      <FormHelperText>{validation.validateField("total")}</FormHelperText>
                    }
                </FormControl>
              </div>
              <div className={classes.viewReceiptContent}>
                {receipt.downloadURL &&
                  <Button onClick={() => this.setState({ showDialog: true })}>
                    View Receipt
                  </Button>
                }
              </div>
            </CardContent>
          </Card>
          <Card className={classNames(classes.cardWidth, classes.column, classes.receiptType, classes.rightCard, classes.padding)}>
            <CardHeader
              title="Receipt Type"
            />
            <CardContent>
              <div>
                <FormControl
                  error={(showValidation && !!validation.validateField("type"))}
                  className={classes.field}
                  fullWidth
                >
                  <InputLabel htmlFor="receipt-simple">Select Receipt Type</InputLabel>
                  <Select
                    value={receipt.type === undefined ? "" : receipt.type}
                    onChange={(event) => {
                      handleChange("type", event.target.value)
                    }}
                    inputProps={{
                      name: 'receiptType',
                      id: 'receipt-simple',
                    }}
                  >
                    <MenuItem value="rebill">Rebill</MenuItem>
                    <MenuItem value="cogs">Cost of Goods Sold</MenuItem>
                    <MenuItem value="expense">Expense</MenuItem>
                  </Select>
                  {showValidation && validation.validateField("type") &&
                    <FormHelperText>{validation.validateField("type")}</FormHelperText>
                  }
                </FormControl>
              </div>
                <div>
                  {receipt.type === "rebill" &&
                    <Rebill
                      showValidation={showValidation}
                      validation={validation}
                      receipt={receipt}
                      handleChange={handleChange}
                    />
                  }
                  {receipt.type === "cogs" &&
                    <Cogs
                      showValidation={showValidation}
                      validation={validation}
                      receipt={receipt}
                      handleChange={handleChange}
                    />
                  }
                  {receipt.type === "expense" &&
                    <Expense
                      showValidation={showValidation}
                      validation={validation}
                      receipt={receipt}
                      handleChange={handleChange}
                    />
                  }
                </div>

            </CardContent>
          </Card>
        </div>
        <Card className={classNames(classes.notes, classes.padding)}>
          <TextField
            margin="dense"
            id="name"
            label="Notes (optional)"
            fullWidth
            multiline={true}
            value={receipt.notes}
            onChange={(event) => handleChange("notes", event.target.value)}
          />
        </Card>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  const vendors = state.vendorsState;
  return {
    vendors: vendors,
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(ReceiptContent);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/Dialog/ReceiptContent.jsx